// @ts-nocheck
/* eslint-disable */

import React, { useEffect } from 'react';
import NoSsr from '@/components/NoSsr/NoSsr';
import { BannerName } from '@/components/Banners/Banners.types';
import { AdManagerBanners } from '@/components/Banners/Banners.constants';
import { useBridgeState } from '@/bridge/hooks';
import { useIsTopBannerVisible } from '@/hooks/useIsTopBannerVisible';

export interface Props {
  bannerName: BannerName;
}

export const AdManagerBanner = ({ bannerName }: Props) => {
  const { isWebView } = useBridgeState();
  const isTopBannerVisible = useIsTopBannerVisible();

  function adjustBackgroundBannerStyles() {
    const rightBanner = document.querySelector('.google-buds-bg-banner');
    const leftBanner = document.querySelector('.google-buds-bg-banner-left');
    const header = document.querySelector('[data-lotriver-header]');
    const headerOffset = header
      ? header.getBoundingClientRect().top + header.clientHeight
      : 0;
    const offsetTop = headerOffset > 0 ? headerOffset : 0;

    if (!rightBanner || !leftBanner) return;

    rightBanner.style.top = `${offsetTop}px`;
    rightBanner.style.height = `${window.innerHeight - offsetTop}px`;
    leftBanner.style.top = `${offsetTop}px`;
    leftBanner.style.height = `${window.innerHeight - offsetTop}px`;
  }

  useEffect(() => {
    if (
      typeof window === 'undefined' ||
      isWebView ||
      !bannerName.includes(BannerName.Background)
    ) {
      return;
    }

    adjustBackgroundBannerStyles();

    addEventListener('resize', adjustBackgroundBannerStyles);
    addEventListener('scroll', adjustBackgroundBannerStyles);
    return () => {
      removeEventListener('resize', adjustBackgroundBannerStyles);
      removeEventListener('scroll', adjustBackgroundBannerStyles);
    };
  }, [isTopBannerVisible]);

  useEffect(() => {
    if (typeof window === 'undefined' || isWebView) return;

    const googletag = window.googletag || (window.googletag = { cmd: [] });

    googletag.cmd.push(() => {
      const bannerConfig = AdManagerBanners[bannerName];

      const existingSlots = googletag.pubads().getSlots();
      const existingSlot = existingSlots.find(
        slot => slot.getSlotElementId() === bannerConfig.blockId
      );

      if (existingSlot) {
        googletag.destroySlots([existingSlot]);
      }

      const slot = googletag.defineSlot(
        bannerConfig.bannerId,
        bannerConfig.sizes,
        bannerConfig.blockId
      );

      if (slot) {
        slot.addService(googletag.pubads());
        googletag.enableServices();
      }
    });

    setTimeout(() => {
      googletag.cmd.push(() => {
        googletag.display(AdManagerBanners[bannerName].blockId);
      });
    }, 0);
  }, [bannerName]);

  return (
    <NoSsr>
      <div
        className={AdManagerBanners[bannerName].blockId}
        id={AdManagerBanners[bannerName].blockId}
      />
    </NoSsr>
  );
};
